const ApiProxy = require("../ApiProxy");

module.exports = {
  async bootstrap() {
    return ApiProxy.get({
      path: "/api/bootstrap/"
    });
  },

  async login({ username, password }) {
    return ApiProxy.post({
      path: "/api/user/login/",
      data: { username, password }
    });
  },

  async getProfile(id) {
    return ApiProxy.get({
      path: `/api/user/profile/${id}/`
    });
  },

  async getMyProfile() {
    return ApiProxy.get({
      path: `/api/user/profile/`
    });
  },

  async editMyProfile(data) {
    let formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }

    return ApiProxy.formPut({
      path: "/api/user/profile/",
      formData
    });
  },

  async register({ username, email, password }) {
    return ApiProxy.post({
      path: "/api/user/register/",
      data: { username, email, password }
    });
  },

  async resetValidation({ username, password }) {
    return ApiProxy.post({
      path: "/api/users/reset_validation/",
      data: {
        username,
        password
      }
    });
  },

  async changePassword({ username, password, newPassword }) {
    return ApiProxy.post({
      path: `/api/user/change_password/`,
      data: {
        username,
        password,
        new_password: newPassword
      }
    });
  },

  async resetPassword({ email }) {
    return ApiProxy.post({
      path: `/api/users/reset_password/`,
      data: {
        email
      }
    });
  },

  async fetchLimitProducts(amount) {
    return ApiProxy.get({
      secure: false,
      path: `/api/product/?limit=${amount}&is_on_shelf=1`
    });
  },

  async fetchStores() {
    return ApiProxy.get({
      path: `/api/store/?no_page=1`
    });
  },

  async fetchRecommend() {
    return ApiProxy.get({
      path: `/api/recommend/`
    });
  },

  async fetchProducts({
    limit,
    offset,
    search,
    label,
    sort,
    store,
    is_on_shelf = null
  }) {
    return ApiProxy.get({
      secure: false,
      path: `/api/product?limit=${limit}&offset=${offset}${
        search ? `&search=${search}` : ""
      }${label ? `&label=${label}` : ""}${sort ? `&ordering=${sort}` : ""}${
        store ? `&store=${store}` : ""
      }${is_on_shelf === null ? `` : `&is_on_shelf=${is_on_shelf}`}`
    });
  },

  async fetchProductById(id) {
    return ApiProxy.get({
      secure: false,
      path: `/api/product/${id}`
    });
  },

  async fetchProductByIds(ids) {
    // @TODO remove fetch all products when api is supported
    const _fetchProductList = async () => {
      let [limit, offset, search, store, label, sort] = [10000, 0, , , ,];
      return ApiProxy.get({
        secure: false,
        path: `/api/product?limit=${limit}&offset=${offset}${
          search ? `&search=${search}` : ""
        }${label ? `&label=${label}` : ""}${sort ? `&ordering=${sort}` : ""}${
          store ? `&store=${store}` : ""
        }`
      });
    };
    let { results: products } = await _fetchProductList();
    let result = [];

    for (let i = 0; i < ids.length; i++) {
      let found = products.find(product => product.id === ids[i]);
      if (!found) {
        throw Error(404);
      }
      result.push(found);
    }
    return result;
  },

  async fetchStoreById(id) {
    return ApiProxy.get({
      secure: false,
      path: `/api/store/${id}`
    });
  },

  async fetchProductsByStoreId(id) {
    return ApiProxy.get({
      secure: false,
      path: `/api/product/?store=${id}&is_on_shelf=1`
    });
  },

  async fetchArticleById(id) {
    return ApiProxy.get({
      path: `/api/article/${id}`
    });
  },

  async fetchArticles({ limit, offset, search, label, sort }) {
    return ApiProxy.get({
      path: `/api/article?limit=${limit}&offset=${offset}${
        search ? `&search=${search}` : ""
      }${label ? `&label=${label}` : ""}${sort ? `&ordering=${sort}` : ""}`
    });
  },

  async fetchItemById(id) {
    return ApiProxy.get({
      path: `/api/items/${id}/`
    });
  },

  async fetchItemsByCategory(id) {
    return ApiProxy.get({
      path: `/api/categories/${id}/items/`
    });
  },

  async fetchItemComments(id) {
    return ApiProxy.get({
      path: `/api/items/${id}/comments/`
    });
  },

  async createItemComment({ item, text }) {
    return ApiProxy.post({
      path: `/api/items/${item.id}/comments/`,
      data: {
        text
      }
    });
  },

  async editItemComment({ item, itemComment, text }) {
    return ApiProxy.put({
      path: `/api/items/${item.id}/comments/${itemComment.id}/`,
      data: {
        text
      }
    });
  },

  async deleteItemComment({ item, itemComment }) {
    return ApiProxy.delete({
      path: `/api/items/${item.id}/comments/${itemComment.id}/`
    });
  },

  async createItemCommentResponse({ item, comment, text }) {
    return ApiProxy.post({
      path: `/api/items/${item.id}/comments/${comment.id}/responses/`,
      data: {
        text
      }
    });
  },

  async editItemCommentResponse({ item, comment, response, text }) {
    return ApiProxy.put({
      path: `/api/items/${item.id}/comments/${comment.id}/responses/${response.id}/`,
      data: {
        text
      }
    });
  },

  async deleteItemCommentResponse({ item, comment, response }) {
    return ApiProxy.delete({
      path: `/api/items/${item.id}/comments/${comment.id}/responses/${response.id}/`
    });
  },

  async createOrder({ currency, paymentType, title }) {
    return ApiProxy.post({
      secure: true,
      path: `/checkout/order/`,
      data: {
        title,
        currency,
        payment_type: paymentType
      }
    });
  },

  async getOrderList() {
    return ApiProxy.get({
      secure: true,
      path: `/checkout/order/`
    });
  },

  async getOrder(id) {
    return ApiProxy.get({
      secure: true,
      path: `/checkout/order/${id}/`
    });
  },

  async fetchStores() {
    return ApiProxy.get({
      path: `/api/store/`
    });
  },

  async creatContactMsg(data) {
    return ApiProxy.post({
      secure: false,
      path: `/api/contact/`,
      data: {
        store_name: data.storeName,
        location: data.location,
        name: data.name,
        phone: data.phone,
        FB_link: data.FBLink,
        physical_store: data.physicalStore,
        pour_over_coffee: data.pourOverCoffee,
        coffee_bean_baking: data.cofferBeanBaking
      }
    });
  },

  // admin
  async getMyStore() {
    return ApiProxy.get({
      secure: true,
      path: `/api/store/my/`
    });
  },

  async editStore(id, data) {
    let formData = new FormData();

    for (let key in data) {
      data[key] && formData.append(key, data[key]);
    }

    return ApiProxy.formPut({
      path: `/api/store/${id}/`,
      formData
    });
  },

  async deleteStoreImagesById(id) {
    return ApiProxy.delete({
      secure: true,
      path: `/api/store_images/${id}/`
    });
  },

  async createStoreImages(id, data) {
    let formData = new FormData();

    for (let key in data) {
      data[key] && formData.append(key, data[key]);
    }

    return ApiProxy.formPost({
      secure: true,
      path: `/api/store/${id}/images/`,
      formData
    });
  },

  async deleteProductImagesById(id) {
    return ApiProxy.delete({
      secure: true,
      path: `/api/product_images/${id}/`
    });
  },

  async createProduct(data) {
    return ApiProxy.post({
      secure: true,
      path: `/api/product/create/`,
      data
    });
  },

  async updateProduct(id, data) {
    return ApiProxy.put({
      secure: true,
      path: `/api/product/${id}/edit/`,
      data
    });
  },

  async updateProductImage(id, data) {
    let formData = new FormData();
    formData.append("image", data.image);
    // @TODO: currently api need name, removed this line after api ready, this is just a note
    // formData.append('name', 'update product name')
    return ApiProxy.formPut({
      secure: true,
      path: `/api/product/${id}/edit/`,
      formData
    });
  },

  async createProductImages(id, data) {
    let formData = new FormData();

    for (let key in data) {
      data[key] && formData.append(key, data[key]);
    }
    if (!formData.product) {
      formData.append("product", id);
    }

    return ApiProxy.formPost({
      secure: true,
      path: `/api/product/${id}/images/`,
      formData
    });
  },

  async listStoreOrder({ from, to }) {
    let appendQuery =
      from || to
        ? `?${from ? `from=${from}` : ""}${from && to ? "&" : ""}${
            to ? `to=${to}` : ""
          }`
        : "";
    return ApiProxy.get({
      secure: true,
      path: `/checkout/store_order/${appendQuery}`
    });
  },

  async updateStoreOrder(id, data) {
    return ApiProxy.put({
      path: `/checkout/store_order/${id}/`,
      data
    });
  }
};
